module.exports = __webpack_public_path__ + "img/ceres_logo.277920c0.png";